var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("Meta Açıklama, "),_c('b',[_vm._v("Anahtar Kelime")]),_vm._v("yi içermeli.")])])}]

export { render, staticRenderFns }